import {Component} from '@angular/core';
import {BaseFieldType} from '../base-field-type';
import {ReactiveFormsModule} from "@angular/forms";

import {FormlyModule} from "@ngx-formly/core";
import {NbInputModule} from "@nebular/theme";

@Component({
    imports: [
    ReactiveFormsModule,
    FormlyModule,
    NbInputModule
],
    templateUrl: './input-filter-property.component.html'
})
export class InputFilterPropertyComponent extends BaseFieldType {
}
